export const zh = {
  "header": {
    "brand": "CikaStudio",
    "tools": "工具",
    "games": "游戏",
    "about": "关于"
  },
  "nav": {
    "tools": "工具",
    "games": "游戏",
    "about": "关于"
  },
  "actions": {
    "copy": "复制",
    "download": "下载",
    "clear": "清空",
    "copied": "已复制!",
    "copyAll": "复制全部",
    "downloadTxt": "下载 TXT",
    "generate": "生成",
    "regenerate": "重新生成",
    "format": "格式化",
    "minify": "压缩",
    "validate": "验证",
    "convert": "转换"
  },
  "footer": {
    "privacy": "隐私",
    "terms": "条款",
    "email": "联系我们",
    "moreTools": "更多工具",
    "copyright": "© {year} CikaStudio. 保留所有权利。"
  },
  "language": {
    "en": "English",
    "zh": "中文"
  },
  "theme": {
    "light": "浅色",
    "dark": "深色"
  },
  "common": {
    "clientSide": "100% 客户端处理",
    "noUpload": "不上传数据",
    "noAccount": "无需账号",
    "loading": "加载中...",
    "error": "错误",
    "success": "成功"
  },
  "colorConverter": {
    "title": "颜色转换器",
    "subtitle": "HEX、RGB、HSL、CMYK 互转。检查对比度，探索配色方案。",
    "privacy": "100% 本地处理",
    "random": "随机颜色",
    "contrast": "对比度检查 (WCAG)",
    "whiteText": "白色文字",
    "blackText": "黑色文字",
    "harmonies": "配色方案",
    "original": "原色",
    "complementary": "互补色",
    "analogous1": "近似色 +30°",
    "analogous2": "近似色 -30°",
    "triadic1": "三角色 +120°",
    "triadic2": "三角色 +240°",
    "split": "分裂互补",
    "cssExport": "CSS 导出",
    "invalidHex": "无效的 HEX 颜色"
  },
  "content": {
    "privacy": {
      "title": "隐私与安全",
      "description": "🔒 所有颜色处理均在您的浏览器本地完成。任何颜色数据都不会被上传到服务器。"
    },
    "guide": {
      "title": "如何使用颜色转换器",
      "description": "在 HEX、RGB、HSL 和 CMYK 颜色格式之间即时转换。",
      "steps": [
        {
          "title": "输入颜色",
          "description": "以任何支持的格式输入颜色：HEX（#ff5733）、RGB（rgb(255,87,51)）、HSL 或 CMYK。工具会自动检测格式。"
        },
        {
          "title": "探索转换结果",
          "description": "查看即时转换为所有其他格式的结果。调整滑块以微调各个通道，并查看实时更新。"
        },
        {
          "title": "检查对比度和配色方案",
          "description": "使用内置对比度检查器确保符合无障碍标准，并探索互补色、三色和类似色配色方案。"
        }
      ]
    },
    "features": {
      "title": "核心功能",
      "items": [
        "HEX、RGB、HSL 和 CMYK 之间的即时转换",
        "自动检测输入颜色格式",
        "WCAG 对比度比率检查器，确保无障碍访问",
        "配色方案探索：互补色、三色、类似色",
        "一键复制任何颜色格式",
        "100% 客户端处理 — 零数据上传"
      ]
    },
    "faq": {
      "title": "常见问题",
      "items": [
        {
          "question": "我的颜色数据会被发送到服务器吗？",
          "answer": "不会。所有颜色转换和计算均在您的浏览器本地完成。没有任何数据被传输或存储到外部。"
        },
        {
          "question": "支持哪些颜色格式？",
          "answer": "转换器支持 HEX（含透明通道）、RGB/RGBA、HSL/HSLA 和 CMYK。所有转换均基于标准色彩空间定义进行数学精确计算。"
        },
        {
          "question": "对比度比率是如何计算的？",
          "answer": "对比度比率使用基于相对亮度的 WCAG 2.1 公式计算。普通文本需要 4.5:1 的比率，大号文本需要 3:1 的比率。"
        }
      ]
    },
    "related": {
      "title": "相关工具",
      "tools": [
        {
          "name": "渐变生成器",
          "url": "/design/gradient-generator",
          "description": "创建精美的 CSS 渐变，支持线性、径向和圆锥渐变。"
        },
        {
          "name": "图片转换器",
          "url": "/image/image-converter",
          "description": "在浏览器中即时转换 JPG、PNG 和 WebP 格式。"
        },
        {
          "name": "CSS 压缩工具",
          "url": "/developer/css-minifier",
          "description": "压缩 CSS 以减小文件大小，实现更快的页面加载。"
        }
      ]
    }
  }
};
